import { ColorEnum, ThemeEnum } from '@app/common';
import { getLuminance } from 'polished';
import { TextVariantType } from '../type/text-type';
import { assetColors } from '../asset-colors';

const ASSET_TEXT_LUMINANCE_THRESHOLD = 0.44;

type AssetColorGroupType = keyof (typeof assetColors)[ThemeEnum.Light];
type AssetColorToneType = 'light' | 'main' | 'dark';

const getAssetColorTone = (color: ColorEnum): AssetColorToneType => {
    if (color.endsWith('Light')) {
        return 'light';
    }

    if (color.endsWith('Dark')) {
        return 'dark';
    }

    return 'main';
};

const getAssetColorGroup = (color: ColorEnum): AssetColorGroupType => {
    return color.replace(/(Light|Dark)$/, '') as AssetColorGroupType;
};

const assetColorToneMap: Record<ColorEnum, { group: AssetColorGroupType; tone: AssetColorToneType }> = Object.values(
    ColorEnum,
).reduce((acc, color) => {
    acc[color] = {
        group: getAssetColorGroup(color),
        tone: getAssetColorTone(color),
    };

    return acc;
}, {} as Record<ColorEnum, { group: AssetColorGroupType; tone: AssetColorToneType }>);

export const getAssetTextVariant = (colorName: ColorEnum, theme: ThemeEnum): TextVariantType => {
    const { group, tone } = assetColorToneMap[colorName];
    const colorHex = assetColors[theme][group][tone];

    return getLuminance(colorHex) > ASSET_TEXT_LUMINANCE_THRESHOLD ? 'black' : 'white';
};
